(function () {
    'use strict';

    angular
        .module('appback')
        .controller('PedidoproveedorController', PedidoproveedorController)

    PedidoproveedorController.$inject = ["PedidoproveedorService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce"];

    function PedidoproveedorController(PedidoproveedorService, $http, $timeout, $uibModal, $log, $document, $sce) {
        var vm = this;

        vm.proveedores = [];
        vm.selectedProveedor = null;
        vm.productos = [];
        vm.carrito = [];

        vm.total = 0;
        vm.subtotal = 0;
        vm.impuestos = 0;

        vm.isLoadingProveedores = false;
        vm.isLoadingProductos = false;

        vm.searchText = '';
        vm.comentario = '';
        vm.productFilter = productFilter;

        // Functions
        vm.onProveedorChange = onProveedorChange;
        vm.addToCart = addToCart;
        vm.increment = increment;
        vm.decrement = decrement;
        vm.removeFromCart = removeFromCart;
        vm.onQuantityChange = onQuantityChange;
        vm.calculateTotals = calculateTotals;
        vm.generarPedido = generarPedido;

        activate();

        function activate() {
            loadProveedores();
        }

        function loadProveedores() {
            vm.isLoadingProveedores = true;
            PedidoproveedorService.getProveedores().then(function (response) {
                vm.proveedores = response.data;
                vm.isLoadingProveedores = false;
            }, function (error) {
                console.error("Error loading suppliers", error);
                vm.isLoadingProveedores = false;
            });
        }

        function onProveedorChange() {
            if (!vm.selectedProveedor) {
                vm.productos = [];
                return;
            }
            vm.isLoadingProductos = true;
            // vm.selectedProveedor is expected to be the ID because of ng-options logic or ng-model binding
            PedidoproveedorService.getProductosProveedor(vm.selectedProveedor).then(function (response) {
                vm.productos = response.data;
                vm.isLoadingProductos = false;
                // Reset cart when supplier changes to avoid mixing products from different suppliers
                vm.carrito = [];
                vm.calculateTotals();
            }, function (error) {
                console.error("Error loading products", error);
                vm.isLoadingProductos = false;
            });
        }

        function addToCart(producto) {
            var existing = vm.carrito.find(function (item) { return item.id === producto.id; });
            if (existing) {
                existing.cantidad++;
            } else {
                vm.carrito.push({
                    id: producto.id,
                    nombre: producto.nombre,
                    sku: producto.sku,
                    precio: parseFloat(producto.precio),
                    iva: producto.iva,
                    cantidad: 1,
                    img: producto.img
                });
            }
            calculateTotals();
        }

        function increment(item) {
            item.cantidad++;
            calculateTotals();
        }

        function decrement(item) {
            item.cantidad--;
            if (item.cantidad <= 0) {
                removeFromCart(item);
            } else {
                calculateTotals();
            }
        }

        function removeFromCart(item) {
            var index = vm.carrito.indexOf(item);
            if (index > -1) {
                vm.carrito.splice(index, 1);
            }
            calculateTotals();
        }

        function onQuantityChange(item) {
            // Only correct negative values
            if (item.cantidad < 0) {
                item.cantidad = 1;
            }
            // We do not force ParseFloat here to avoid breaking typing of decimals (like "0.")
            // Calculation will handle the values
            calculateTotals();
        }

        function calculateTotals() {
            var sub = 0;
            var tax = 0;
            vm.carrito.forEach(function (item) {
                var qty = item.cantidad ? parseFloat(item.cantidad) : 0;
                var lineTotal = item.precio * qty;
                sub += lineTotal;
                tax += lineTotal * (item.iva / 100);
            });
            vm.subtotal = sub;
            vm.impuestos = tax;
            vm.total = sub + vm.impuestos;
        }

        vm.orderSuccess = false;
        vm.successOrderId = null;
        vm.resetOrder = resetOrder;

        function generarPedido() {
            if (vm.carrito.length === 0) {
                alert("El carrito está vacío. Añada productos antes de generar el pedido.");
                return;
            }

            if (!vm.selectedProveedor) {
                alert("Debe seleccionar un proveedor.");
                return;
            }

            var datos = {
                Pedidoproveedor: {
                    proveedor_id: vm.selectedProveedor,
                    precio_pedido: vm.total,
                    subtotal_pedido: vm.subtotal,
                    comentario: vm.comentario
                },
                items: JSON.stringify(vm.carrito),
            };

            PedidoproveedorService.generarPedido(datos).then(function (response) {
                if (response.data.success) {
                    vm.orderSuccess = true;
                    vm.successOrderId = response.data.pedido_id;
                    vm.carrito = [];
                    vm.calculateTotals();
                } else {
                    alert("Ocurrió un error al generar el pedido: " + (response.data.message || 'Error desconocido.'));
                }
            }, function (error) {
                console.error("Error generating order", error);
                alert("Error de conexión al generar el pedido.");
            });
        }

        function resetOrder() {
            vm.orderSuccess = false;
            vm.successOrderId = null;
            vm.selectedProveedor = null;
            vm.productos = [];
            vm.searchText = '';
            vm.comentario = '';
        }

        function productFilter(item) {
            if (!vm.searchText) return true;
            var text = vm.searchText.toLowerCase();
            var nombre = item.nombre ? item.nombre.toLowerCase() : '';
            var descripcion = item.descripcion ? item.descripcion.toLowerCase() : '';
            return nombre.indexOf(text) > -1 || descripcion.indexOf(text) > -1;
        }
    }

})();